var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-tm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h496v496H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "scale(1.0321)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M0 0h744v496H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.1 133.2c27 13 59.2 0 70.9-18 12-16.8 13.4-45-7.3-70.9 32 26.6 39.2 56.7 23.2 81.5-21.2 28.3-68.4 27.5-86.8 7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297 76.2 1.5-5.4-4.4-3.3 5.4-.2 1.8-5.3 1.8 5.3h5.4l-4.3 3.5 1.6 5.3-4.4-3.2zm-27 33.6 1.6-5.3-4.4-3.4 5.5-.1 1.7-5.3 1.9 5.2 5.4.1-4.3 3.4 1.6 5.4-4.5-3.2zm1.8-26.5 1.6-5.4-4.4-3.3 5.4-.2 1.8-5.3 1.8 5.3h5.5l-4.3 3.5 1.6 5.3-4.5-3.2zm0-26.6 1.6-5.4L269 48l5.4-.2 1.8-5.3 1.8 5.3h5.5l-4.3 3.5 1.6 5.3-4.5-3.1zM242 90.4l1.5-5.4-4.3-3.4 5.4-.1 1.8-5.3 1.8 5.2 5.4.1-4.3 3.4 1.6 5.4-4.5-3.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M46 0h159.5v496H46.1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 129.3v-3.5l6.7-8.9-1.4-1.7 4-5.4-1.3-1.7-2.7 3.5-1.3-1.8 9.3-12.4 1.3 1.8-1.3 1.8 2.7 3.6 6.6-9-6.7-8.5-2.6 3.3 1.3 1.7-1.3 1.8L50 81.5l1.3-1.8 2.7 3.6 1.3-1.8-4-5.3 1.4-1.8-6.6-8.8V62l9.2 12.4-1.3 1.8 4 5.3-2.7 3.5 2.7 3.6 4-5.3 9.3 12.6L62 108l-4-5.3-2.7 3.5 2.7 3.5-4 5.4 1.3 1.7-9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 85 1.4 3.6v5.3h4l2.6 1.8-2.6 1.7h-4v5.4l-1.3 3.5V85z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 214.4v-3.6l6.7-8.8-1.4-1.8 4-5.3L54 193l-2.7 3.5L50 195l9.3-12.4 1.3 1.7-1.3 1.8 2.7 3.6 6.6-8.9-6.7-8.6-2.6 3.3 1.3 1.8-1.3 1.7-9.3-12.4 1.3-1.7 2.7 3.5 1.3-1.8-4-5.3 1.4-1.7-6.6-9V147l9.2 12.4-1.3 1.8 4 5.3-2.7 3.6 2.7 3.5 4-5.3 9.3 12.6-9.3 12.2-4-5.3-2.7 3.5L58 195l-4 5.3 1.3 1.8-9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 170 1.4 3.6v5.3h4l2.6 1.8-2.6 1.8h-4v5.3l-1.3 3.5v-21.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 299.4v-3.5l6.7-8.9-1.4-1.8 4-5.3-1.3-1.7-2.7 3.5-1.3-1.8 9.3-12.4 1.3 1.8-1.3 1.8 2.7 3.5 6.6-8.9-6.7-8.6-2.6 3.3 1.3 1.8-1.3 1.8-9.3-12.4 1.3-1.8 2.7 3.5 1.3-1.7-4-5.3 1.4-1.8-6.6-8.9v-3.5l9.2 12.4-1.3 1.8 4 5.3-2.7 3.5 2.7 3.6 4-5.3 9.3 12.6-9.3 12.2-4-5.4-2.7 3.6 2.7 3.5-4 5.3 1.3 1.8-9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 255.1 1.4 3.6v5.3h4l2.6 1.8-2.6 1.7h-4v5.3l-1.3 3.6V255z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 379.1v-3.5l6.7-8.9-1.4-1.7 4-5.4L54 358l-2.7 3.5-1.3-1.8 9.3-12.4 1.3 1.8-1.3 1.8 2.7 3.6 6.6-9-6.7-8.5-2.6 3.3 1.3 1.7-1.3 1.8-9.3-12.4 1.3-1.8 2.7 3.6 1.3-1.8-4-5.3 1.4-1.8-6.6-8.8v-3.6l9.2 12.4L54 326l4 5.3-2.7 3.5 2.7 3.6 4-5.3 9.3 12.6-9.3 12.2-4-5.3-2.7 3.5 2.7 3.5-4 5.4 1.3 1.7-9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 334.8 1.4 3.6v5.3h4l2.6 1.8-2.6 1.7h-4v5.4L46 356v-21.3z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 129.3v-3.5l-6.6-8.9 1.3-1.7-4-5.4 1.4-1.7 2.7 3.5 1.3-1.8-9.3-12.4-1.4 1.8 1.4 1.8-2.8 3.6-6.5-9 6.6-8.5 2.7 3.3-1.4 1.7 1.4 1.8 9.3-12.4-1.4-1.8-2.6 3.6-1.3-1.8 4-5.3-1.4-1.8 6.6-8.9V62l-9.2 12.4 1.3 1.8-4 5.3 2.7 3.5-2.7 3.6-4-5.3-9.3 12.6 9.3 12.2 4-5.3 2.7 3.5-2.7 3.5 4 5.4-1.3 1.7 9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5 85-1.3 3.6v5.3h-4l-2.7 1.8 2.7 1.7h4v5.4l1.3 3.5V85z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 214.4v-3.6l-6.7-8.8 1.4-1.8-4-5.3 1.3-1.8 2.7 3.6 1.3-1.8-9.3-12.4-1.3 1.7 1.3 1.8-2.7 3.6-6.6-8.9 6.7-8.6 2.6 3.3-1.3 1.8 1.3 1.7 9.3-12.4-1.3-1.7-2.7 3.5-1.3-1.8 4-5.3-1.3-1.7 6.5-9v-3.4l-9.2 12.4 1.3 1.7-4 5.3 2.7 3.6-2.7 3.5-4-5.3-9.3 12.6 9.4 12.2 4-5.3 2.6 3.5-2.7 3.6 4 5.3-1.3 1.8 9.3 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206 170-1.4 3.6v5.3h-4l-2.6 1.8 2.6 1.8h4v5.3l1.3 3.5v-21.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 299.4v-3.5L199 287l1.3-1.8-4-5.3 1.4-1.7 2.7 3.5 1.3-1.8-9.3-12.4-1.4 1.8 1.4 1.8-2.8 3.5-6.5-8.9 6.6-8.6 2.7 3.3-1.4 1.8 1.4 1.8 9.3-12.4-1.4-1.8-2.6 3.5-1.3-1.7 4-5.3-1.4-1.8 6.6-8.9v-3.5l-9.2 12.4 1.3 1.8-4 5.3 2.7 3.5-2.7 3.6-4-5.3-9.3 12.6 9.3 12.2 4-5.4 2.7 3.6-2.7 3.5 4 5.3-1.3 1.8 9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5 255.1-1.3 3.6v5.3h-4l-2.7 1.8 2.7 1.7h4v5.3l1.3 3.6V255z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.5 379.1v-3.5l-6.6-8.9 1.3-1.7-4-5.4 1.4-1.7 2.7 3.5 1.3-1.8-9.3-12.4-1.4 1.8 1.4 1.8-2.8 3.6-6.5-9 6.6-8.5 2.7 3.3-1.4 1.7 1.4 1.8 9.3-12.4-1.4-1.8-2.6 3.6-1.3-1.8 4-5.3-1.4-1.8 6.6-8.8v-3.6l-9.2 12.4 1.3 1.8-4 5.3 2.7 3.5-2.7 3.6-4-5.3-9.3 12.6 9.3 12.2 4-5.3 2.7 3.5-2.7 3.5 4 5.4-1.3 1.7 9.2 12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5 334.8-1.3 3.6v5.3h-4l-2.7 1.8 2.7 1.7h4v5.4l1.3 3.5v-21.3z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M46 33.7V30l6.7-8.8-1.4-1.8 4-5.3-1.3-1.8-2.7 3.5-1.3-1.7 9.3-12.4 1.3 1.7-1.3 1.8L62 9l6.6-9h2.7L62 12.4l-4-5.3-2.7 3.5 2.7 3.6-4 5.3 1.3 1.8-9.2 12.4zM46 0h8l-2.6 1.8h-4V7l-1.3 3.5V0zm159.5 33.7V30l-6.6-8.8 1.3-1.8-4-5.3 1.4-1.8 2.6 3.5 1.4-1.7-9.3-12.4-1.4 1.7 1.4 1.8-2.8 3.6-6.5-9h-2.7l9.3 12.5 4-5.3 2.7 3.5-2.7 3.6 4 5.3-1.3 1.8 9.2 12.4zm0-33.7h-8l2.7 1.8h4V7l1.3 3.5V0zM112.5 489s5.7-10 20.2-13.1c14.4-3 16.9 6.7 25.1 6.7 8.2 0 21.3-6.7 21.3-6.7s-13 12.8-23.1 12.5c-10-.3-13.5-6.7-23.8-5.8-10.3 1-19.7 6.7-19.7 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M140.3 489s-5.7-10-20.1-13.1c-14.4-3-17 6.7-25.2 6.7s-21.3-6.7-21.3-6.7 13.1 12.8 23.2 12.5c10-.3 13.5-6.7 23.8-5.8 10.3 1 19.6 6.7 19.6 6.4z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2 472.4c-1.3-2.7-4.4-14.3-2.8-15.7 2.6-1 9.3 10.9 8.7 21.5-4.4 2.4-19.4-1-19.2-4.1 1-4.4 9.5-3 13.3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1 462.3c-.8-3-2.1-15.2-.2-16.2 2.6-.2 7.4 13.2 5.1 23.4-4.7 1.2-18.9-6.2-18.2-9.3 1.7-4 9.8-.2 13.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 451c-.6-3.1-.8-15.5 1.1-16.1 2.7.1 6.2 14.2 3 24-4.7.4-18.1-9.2-17.2-12 2-3.8 9.7 1.2 13 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 438.8c-.3-3.1 1-15.3 3-15.6 2.6.7 4.4 15.4.2 24.4-4.8-.6-17-12.9-15.7-15.5 2.5-3.2 9.5 3.3 12.4 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9 426.2c.1-3.2 2.7-15 4.7-14.9 2.4 1.2 2.7 16.1-2.5 24.2-4.6-1.5-15.3-16-13.8-18.4 2.8-2.7 9 5.1 11.6 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68 411.8c-.3 12.6-2.6 12.7-6.8 3.4-1.8-3.5-2-18-.4-18.6 2.4 0 7.1 10.3 7.2 15.2z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#faae29",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159 473.7c1.2-2.6 4.4-14.3 2.7-15.7-2.6-1-9.3 10.9-8.7 21.5 4.5 2.4 19.5-1 19.3-4.1-1.1-4.3-9.6-2.9-13.4-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 463.6c.8-3 2.1-15.2.3-16.2-2.7-.2-7.5 13.3-5.2 23.5 4.7 1.1 19-6.3 18.2-9.3-1.7-4-9.8-.3-13.3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4 452.2c.5-3 .8-15.4-1.2-16-2.6.2-6.2 14.3-3 24 4.8.5 18.2-9.2 17.2-12-2-3.7-9.7 1.3-13 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2 440.2c.2-3.2-1-15.4-3-15.6-2.6.7-4.5 15.3-.2 24.4 4.7-.6 16.9-13 15.6-15.6-2.5-3.2-9.4 3.3-12.4 6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.2 427.5c-.1-3.1-2.6-15-4.6-14.9-2.5 1.2-2.8 16.1 2.4 24.2 4.7-1.5 15.3-16 13.8-18.3-2.8-2.7-9 5-11.6 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1 413.1c.4 12.6 2.7 12.8 6.8 3.4 1.9-3.5 2.1-18 .4-18.6-2.4 0-7.1 10.4-7.2 15.2z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.96875 0 0 1.2258 182.4 -74.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-3.5 290.6H-9v3.5h-5.3v3.5h-21.2l-3.6 3.6 1.8 1.8h8.9l1.7-1.8h-8.8l1.7-1.8h12.4l-5.3 5.3H-39l-3.5-1.7-3.6 1.7h-12.4l-5.3-5.3h12.4l1.8 1.8h-8.9l1.8 1.8h8.9l1.7-1.8-3.5-3.6h-19.5v-3.5h-5.3v-3.5h-5.3v-16h5.3v-3.5h5.3v-3.6h19.5l3.5-3.5-1.7-1.8h-8.9l-1.8 1.8h8.9l-1.8 1.7h-12.4l5.3-5.3H-46l3.6 1.8 3.5-1.8h12.4l5.3 5.3h-12.4l-1.7-1.7h8.8l-1.8-1.8h-8.8L-39 264l3.6 3.5h21.2v3.6h5.3v3.5h5.4v16z",
    transform: "matrix(1.4884 0 0 1.24 3.5 -39.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#faae29",
    strokeWidth: "1pt",
    d: "M375.6 499.7v24.8h10.6v7h10.6v7h35.5l14.2 10.7 14.1-10.6h39v-7l10.6-.1v-7H521v-24.9h-10.7v-7h-10.6v-7.2h-39l-14.1-10.6-14.2 10.6h-35.5v7.2h-10.6v7h-10.6z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m-75.6 296.6-15.8 11v-11h15.8zm31.6 0 15.9 11v-11H-44zm-31.6 28.6-15.8-11v11h15.8zm31.6 0 15.9-11v11H-44zm5.3-22-5.3 4.4h10.6l-5.3-4.4zm-42.2 0-5.2 4.4h10.5l-5.3-4.4zm0 15.4-5.2-4.4h10.5l-5.3 4.4zm42.2 0-5.3-4.4h10.6l-5.3 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "m-59.8 329.6-5.3-4.4h10.6l-5.3 4.4zm0-22-5.3-4.4h10.6l-5.3 4.4zm0-15.4-5.3 4.5h10.6l-5.3-4.5zm0 22-5.3 4.4h10.6l-5.3-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M467.7 506.7H482v3.5h-14.2z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M414.6 510.2h7v3.6h-7zm56.7 0h7v3.6h-7z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M439.4 489h14.1v3.5h-14.1zm0 7h14.1v3.6h-14.1z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#900",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M435.8 492.5h21.3v3.6h-21.3zm3.6 32h14.1v3.4h-14.1zm0 7h14.1v3.5h-14.1zm-3.6-3.5h21.3v3.5h-21.3z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M467.7 513.8H482v3.5h-14.2zm-56.7-7.1h14.2v3.5H411zm0 7h14.2v3.6H411zm-3.5-3.5h7v3.6h-7zm14.2 0h7v3.6h-7zm42.5 0h7v3.6h-7zm14.2 0h7v3.6h-7z",
    transform: "matrix(.74419 0 0 .62 -392 -6.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.1 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.6 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361 -39)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.5 -41.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -41.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -36.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -36.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -353.2 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -346.6 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -340 -50)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.5 -52.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.7 -52.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -350.6 -47.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -342.7 -47.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -374.2 -60.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -367.6 -60.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -361 -61)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -63.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -63.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -371.6 -58.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -363.7 -58.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -395.3 -49.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -388.7 -49.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -382.1 -49.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.6 -52)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.8 -52)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -392.7 -47.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 413.7,
    cy: 582,
    r: 0.9,
    fill: "#fff",
    transform: "matrix(.74419 0 0 .62 -384.8 -47.6)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m134.6 247.8 4.4-2 4.4 2h-8.8zm-13.2 0 4.4-2 4.4 2h-8.8zm-13.2 0 4.4-2 4.4 2h-8.8zm26.4-47.4 4.4 2.1 4.4-2h-8.8zm-13.2 0 4.4 2.1 4.4-2h-8.8zm-13.2 0 4.4 2.1 4.4-2h-8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m131 254-5.2 4.1-5.1-4.1-5.2 4.1-5-4.1v2l3.3 2.1-1.7 2v2.1h1.7l1.7-2 1.7 2h1.7v-2l-1.7-2.1 3.5-2 3.4 2-1.7 2v2.1h1.7l1.7-2 1.7 2h1.7v-2l-1.7-2.1 3.4-2 3.4 2-1.7 2v2.1h1.7l1.7-2 1.7 2h1.7v-2l-1.7-2.1 3.5-2V254l-5.2 4-5-4.1zm0-59.7-5.2-4.2-5.1 4.2-5.2-4.2-5 4.2v-2.1l3.3-2-1.7-2.1v-2h1.7l1.7 2 1.7-2h1.8v2l-1.7 2 3.4 2.1 3.4-2-1.7-2.1v-2h1.7l1.7 2 1.7-2h1.7v2l-1.7 2 3.4 2.1 3.4-2-1.7-2.1v-2h1.7l1.7 2 1.7-2h1.8v2l-1.7 2 3.4 2.1v2l-5.2-4-5 4zm38.7 34.3 5.5-4.5-5.5-4.4 5.5-4.5-5.5-4.5h2.8l2.7 3 2.8-1.5h2.7v1.5l-2.7 1.5 2.7 1.5v1.5H178l-2.8-1.5-2.7 3 2.7 3 2.8-1.6h2.7v1.5l-2.7 1.5 2.7 1.5v1.5H178l-2.8-1.5-2.7 3 2.7 3 2.8-1.5h2.7v1.5L178 233l2.7 1.5v1.5H178l-2.8-1.5-2.7 3h-2.8l5.5-4.5-5.5-4.4zm-87.9 0-5.5-4.5 5.5-4.4-5.5-4.5 5.5-4.5h-2.7l-2.8 3-2.7-1.5h-2.7v1.5l2.7 1.5-2.7 1.5v1.5h2.7l2.8-1.5 2.7 3-2.8 3-2.7-1.6h-2.7v1.5l2.7 1.5-2.7 1.5v1.5h2.7l2.8-1.5 2.7 3-2.8 3-2.7-1.5h-2.7v1.5l2.7 1.4-2.7 1.5v1.5h2.7l2.8-1.5 2.7 3h2.7l-5.5-4.5 5.5-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-26.6 214.4h1.8v1.7h-1.8zm-1.8 1.7h1.8v1.8h-1.7zm-8.8 8.9h1.8v1.8h-1.8zm1.8-1.8h1.7v1.8h-1.7zm-58.5 0h1.8v1.8H-94zm-8.9-8.8h1.8v1.7h-1.8zm1.8 1.7h1.8v1.8h-1.8zm0-39h1.8v1.8h-1.8zm-1.8 1.8h1.8v1.8h-1.8zm10.7-10.6h1.7v1.8H-92zm-1.8 1.8h1.8v1.8H-94zm56.7-1.8h1.8v1.8h-1.8zm1.8 1.8h1.7v1.8h-1.7zm7 7h1.8v1.8h-1.7zm1.8 1.9h1.8v1.7h-1.8zM-92 225h1.7v1.8H-92z",
    transform: "matrix(1.24 0 0 1.1622 204.9 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119 224.1h-6.4v-4h4.3v-3.8h4.3v-3.5h4.4v4.3c-3.6 0-6.5 3-6.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M132 224.1h6.5v-4h-4.3v-3.8h-4.3v-3.5h-4.3v4.3c3.5 0 6.4 3 6.4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132 224.1h6.5v4h-4.3v3.9h-4.3v3.4h-4.3v-4.3c3.5 0 6.4-3 6.4-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M119 224.1h-6.4v4h4.3v3.9h4.3v3.4h4.4v-4.3c-3.6 0-6.5-3-6.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M132 224.1h-6.4v-7c3.5 0 6.4 3.2 6.4 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M132 224.1h-6.4v7c3.5 0 6.4-3.1 6.4-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M119 224.1h6.6v7c-3.6 0-6.5-3.1-6.5-7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M119 224.1h6.6v-7c-3.6 0-6.5 3.2-6.5 7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m132.4 249.8-6.6-4-6.6 4-6.6-4-6.6 4v-2l4.4-2-2.2-2.1v-2h2.2l2.2 2 2.2-2h2.2v2l-2.2 2 4.4 2.1 4.4-2-2.2-2.1v-2h2.2l2.2 2 2.2-2h2.2v2l-2.2 2 4.4 2.1 4.4-2-2.2-2.1v-2h2.2l2.2 2 2.2-2h2.2v2l-2.2 2 4.4 2.1v2l-6.6-4-6.6 4zm0-51.4-6.6 4.1-6.6-4.1-6.6 4.1-6.6-4.1v2l4.4 2.1-2.2 2v2.1h2.2l2.2-2 2.2 2h2.2v-2l-2.2-2 4.4-2.2 4.4 2.1-2.2 2v2.1h2.2l2.2-2 2.2 2h2.2v-2l-2.2-2 4.4-2.2 4.4 2.1-2.2 2v2.1h2.2l2.2-2 2.2 2h2.2v-2l-2.2-2 4.4-2.2v-2l-6.6 4.1-6.6-4.1zm24.1 30.9-3.3-5.2 3.3-5.1-3.3-5.2 3.3-5.1H155l-1.7 3.4-1.6-1.7H150v1.7l1.7 1.7-1.7 1.7v1.7h1.7l1.6-1.7 1.7 3.5-1.7 3.4-1.6-1.7H150v1.7l1.7 1.7-1.7 1.7v1.8h1.7l1.6-1.8 1.7 3.5-1.7 3.4-1.6-1.7H150v1.7l1.7 1.7-1.7 1.7v1.8h1.7l1.6-1.8 1.7 3.5h1.6l-3.3-5.2 3.3-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-101 177.2-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm-1.8-5.4-17.7 17.8v16l17.8 17.6h35.4l17.7-17.7v-16l-17.7-17.7h-35.4z",
    transform: "matrix(1.24 0 0 1.1622 231.2 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 .7748 208.4 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 -.7748 208.4 312.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 -.7748 222.4 312.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 .7748 222.4 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 -.7748 201.4 312.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 -.7748 215.4 312.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 -.7748 229.5 312.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(1.8599 0 0 -1.7432 293.8 558.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m95 229.3 3.3-5.2L95 219l3.3-5.2-3.3-5.1h1.7l1.6 3.4 1.7-1.7h1.6v1.7l-1.6 1.7 1.6 1.7v1.8H100l-1.7-1.8-1.6 3.5 1.6 3.4 1.7-1.7h1.6v1.7l-1.6 1.7 1.6 1.7v1.8H100l-1.7-1.8-1.6 3.5 1.6 3.4 1.7-1.7h1.6v1.7l-1.6 1.7 1.6 1.7v1.8H100l-1.7-1.8-1.6 3.5H95l3.3-5.2-3.3-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.24 0 0 1.046 253.2 57.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-99.2 180.7-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z",
    transform: "matrix(1.24 0 0 1.1622 222.4 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 .7748 201.4 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 .7748 215.4 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-93.9 147 3.5 5.4 3.6-5.4H-94z",
    transform: "matrix(.992 0 0 .7748 229.5 136)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-99.2 180.7-3.6 3.6v26.5l3.6 3.6h-5.3v-33.7h5.3z",
    transform: "matrix(-1.24 0 0 1.1622 29.1 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(-1.8599 0 0 -1.7432 -42.3 558.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(-1.8599 0 0 1.7432 -42.3 -110.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-104.5 180.7 3.5-3.5h-3.5v3.5z",
    transform: "matrix(1.8599 0 0 1.7432 293.8 -110.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.4,
    d: "m-101 177.2-7 7v26.6l7 7.1h32l7-7v-26.6l-7.1-7.1H-101zm0-1.8-8.8 8.8v26.6l8.8 8.9h32l8.8-8.9v-26.6l-8.9-8.8H-101z",
    transform: "matrix(1.24 0 0 1.1622 231.2 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.24 0 0 1.04607 253.2 61)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.24 0 0 1.046 253.2 64.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.24 0 0 1.04607 253.2 68.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(1.24 0 0 1.04607 253.2 53.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.24 0 0 1.046 -1.6 57.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.24 0 0 1.04607 -1.6 61)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.24 0 0 1.046 -1.6 64.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.24 0 0 1.04607 -1.6 68.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-76.2 154.1h7.1l1.8 1.8-1.8 1.8h-7V154z",
    transform: "matrix(-1.24 0 0 1.04607 -1.6 53.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#970000",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "M-101 179v37h8.9v8.9h56.7V216h8.8v-37h-8.8v-8.8h-56.7v8.8h-8.9zm1.8 1.7v33.7h8.8v8.8h53.2v-8.8h8.9v-33.7h-8.9V172h-53.2v8.8h-8.8z",
    transform: "matrix(1.24 0 0 1.1622 204.9 -5.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m-28.4 69.1-5.3-7.1v-5.3l-5.3-5.3h-10.6l-8.9-5.3h-28.3l-8.9 5.3h-10.6l-5.3 5.3V62l-5.3 7v14.3l5.3 7v5.4l5.3 5.3h10.6l8.9 5.3h28.3l8.9-5.3H-39l5.4-5.3v-5.3l5.3-7.1V69z",
    transform: "matrix(1.24 0 0 1.1176 215.9 -35.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M73 49.6v6l6.7 7.9v6l6.6 5.9h13.1l11 5.9h15.4V49.6H73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m107.3 63.5-8 5h-4.9l1.6 1.8-3.2 3.4 1.6 1.7 4.8-1.7 1.6 1.7.8-4.6 8.8-5.4-3.2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m98.5 59.5-8 5.1h-4.9l1.6 1.7-3.2 3.4 1.6 1.7 4.8-1.7 1.6 1.7.8-4.6 8.8-5.3-3.1-2zm-4.4-8-8 5.2h-4.9l1.6 1.7-3.2 3.4 1.6 1.7 4.8-1.7 1.6 1.7.8-4.6 8.8-5.3-3.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M178.5 49.6v-6l-6.6-7.8v-6l-6.6-6h-13.2l-11-5.9h-15.3v31.7h52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M125.8 81.3h-4l-4.8-4h-7.5l-4-2 2-2 4 2h4.1l4-5.9 6.2 2v4h-6.1l6 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73 49.6v-6l6.7-7.8v-6l6.6-6h13.1l11-5.9h15.4v31.7H73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M125.8 18h-4l-4.8 3.9h-7.5l-4 2 2 2 4-2h4.1l4 5.9 6.2-2v-4h-6.1l6-5.9zm0 0h4l4.8 3.9h7.5l4 2-2 2-4-2H136l-4.1 5.9-6.1-2v-4h6l-6-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M178.5 49.6v6l-6.6 7.9v6l-6.6 5.9h-13.2l-11 5.9h-15.3V49.6h52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M125.8 81.3h4l4.8-4h7.5l4-2-2-2-4 2H136l-4.1-5.9-6.1 2v4h6l-6 5.9zM98.5 39.7l-8-5h-4.9l1.6-1.8-3.2-3.4 1.6-1.7 4.8 1.7 1.6-1.7.8 4.6 8.8 5.3-3.1 2zm45.8-4 8-5h4.8l-1.5-1.8 3.2-3.3-1.7-1.7-4.7 1.7-1.7-1.7-.7 4.5-8.8 5.4 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m107.3 35.8-8-5.1h-4.9l1.6-1.8-3.2-3.3 1.6-1.7 4.8 1.7 1.6-1.7.8 4.5 8.8 5.4-3.2 2zM94 47.5l-8-5h-4.9l1.6-1.8-3.2-3.4 1.6-1.7 4.8 1.7 1.6-1.7.8 4.6 8.8 5.3-3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77 49.6h2l2 2 2-2h42.8v27.7h-2l2 2v2l-6.1-6v-2h2v2h2v-2l-16.4-8.7h-14v-8.5l-6.1-4.5H83l-2 2 2 2h-2l-4.1-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M77 49.6h2l2-2 2 2h42.8V21.9h-2l2-2v-2l-6.1 6v2h2v-2h2v2l-16.4 8.7h-14v8.6l-6.1 4.4H83l-2-2 2-2h-2l-4.1 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M86.3 49.6h39.5v23.8l-17.6-10H95v-7.9l-8.7-5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m153.1 39.7 8-5h4.8l-1.6-1.8 3.2-3.4-1.6-1.7-4.8 1.7-1.6-1.7-.7 4.6-8.8 5.3 3.1 2zm4.4 8 8-5.2h4.8l-1.6-1.7 3.2-3.4-1.6-1.7-4.8 1.7-1.6-1.7-.7 4.6-8.8 5.3 3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M174.6 49.6h-2l-2-2-2.1 2h-42.7V21.9h2l-2-2v-2l6 6v2h-2v-2h-2v2l16.5 8.7h14v8.6l6.1 4.4h4l2.1-2-2-2h2l4 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M165.3 49.6h-39.5V26l17.6 9.9h13.1v7.9l8.8 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m144.3 63.5 8 5h4.9l-1.6 1.8 3.2 3.4-1.6 1.7-4.8-1.7-1.6 1.7-.8-4.6-8.8-5.4 3.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m153.1 59.5 8 5.1h4.8l-1.6 1.7 3.2 3.4-1.6 1.7-4.8-1.7-1.6 1.7-.7-4.6-8.8-5.3 3.1-2zm4.4-8 8 5.2h4.8l-1.6 1.7 3.2 3.4-1.6 1.7-4.8-1.7-1.6 1.7-.7-4.6-8.8-5.3 3.1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M174.6 49.6h-2l-2 2-2.1-2h-42.7v27.7h2l-2 2v2l6-6v-2h-2v2h-2v-2l16.5-8.7h14v-8.5l6.1-4.5h4l2.1 2-2 2h2l4-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M165.3 49.6h-39.5v23.8l17.6-10h13.1v-7.9l8.8-5.9zm-79 0h39.5V26l-17.6 9.9H95v7.9l-8.7 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m130.1 49.6 11-6h6.7l-2.2-2 4.4-3.9-2.3-2-6.5 2-2.2-2-1 5.3-12.2 6.3 4.3 2.3zm-8.6 0-11 6h-6.7l2.2 2-4.4 3.9 2.2 2 6.6-2 2.2 2 1-5.3 12.2-6.3-4.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "m121.5 49.6-11-6h-6.7l2.2-2-4.4-3.9 2.2-2 6.6 2 2.2-2 1 5.3 12.2 6.3-4.4 2.3zm8.6 0 11 6h6.7l-2.2 2 4.4 3.9-2.3 2-6.5-2-2.2 2-1-5.3-12.2-6.3 4.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.6 49.6 13.2-9.9 13.2 9.9-13.2 9.9-13.2-9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m83 53.6 2.1 2-2 2h-2l-6.2-8h2l4.1 6h2l-2-2 2-2h4.1v2h-4zm0-8 2.1-2-2-2h-2l-6.2 8h2l4.1-6h2l-2 2 2 2h4.1v-2h-4zm85.5 8-2 2 2 2h2l6.1-8h-2l-4 6h-2.1l2-2-2-2h-4v2h4zm0-8-2-2 2-2h2l6.1 8h-2l-4-6h-2.1l2 2-2 2h-4v-2h4zm-44.8-4h4.1v16h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M117.7 45.6h16.2v8h-16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m333 170-10.6 5.4v8.8l10.7 5.4h10.6l10.6-5.4v-8.8l-10.6-5.3h-10.6z",
    transform: "matrix(3.4444 0 0 3.7273 -1039.8 -283.1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M84.5 384h2.2v-4.1H91v4h2.2v-9.4H91v4h-4.4v-4h-2.2v9.4zm56 31.5h2.3v-4h4.4v4h2.2V406h-2.2v4.1h-4.4v-4h-2.2v9.4zm-35.4-47.3h2.2V364h4.5v4h2.2v-9.4h-2.2v4h-4.4v-4H105v9.5zm32.5 0h2.2V364h4.4v4h2.3v-9.4h-2.3v4h-4.4v-4h-2.2v9.5zm20.7 15.7h2.2v-4h4.4v4h2.2v-9.4H165v4h-4.4v-4h-2.2v9.4zm0 15.8h2.2v-4h4.4v4h2.2v-9.4H165v4h-4.4v-4h-2.2v9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "M125.8 421.9V387h53.1v15.8l-35.4 19h-17.7zm0-69.5V387H72.6v-15.8l35.5-19h17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M125.8 352.4V387h53.1v-15.8l-35.4-19h-17.7zm0 69.5V387H72.6v15.8l35.5 19h17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(1 0 0 .8913 331.3 44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M108 376v22.2h5.4l12.4 6.3 12.4-6.3h5.3V376h-5.3l-12.4-6.4-12.4 6.4H108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(-1 0 0 -.8913 -79.7 729.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(-1 0 0 .8913 -79.7 44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M-177.2 368.5h21.3l-21.3-10.6v10.6zm24.8-1.8v17.7H-186v-14.1h-7.1l-8.9-5.3v-12.4l5.4-5.4h-7.1V365h-1.8v-19.5h17.7l35.4 21.2z",
    transform: "matrix(1 0 0 -.8913 331.3 729.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M83.3 399.8h2.2V395h4.4v4.7h2.2v-11H90v4.7h-4.4v-4.7h-2.2v11zm21.2 15.7h2.2v-4.7h4.5v4.7h2.2v-11h-2.2v4.7h-4.5v-4.7h-2.2v11zm-21.2-41h2.2v4.7h4.4v-4.7h2.2v11H90v-4.7h-4.4v4.7h-2.2v-11zm21.2-15.8h2.2v4.7h4.5v-4.7h2.2v11h-2.2V365h-4.5v4.7h-2.2v-11zm33.7 56.8h2.2v-4.7h4.4v4.7h2.3v-11h-2.3v4.7h-4.4v-4.7h-2.2v11zm21.3-30h2.2v-4.7h4.4v4.7h2.2v-11h-2.2v4.7h-4.4v-4.7h-2.2v11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M138.2 415.5h2.2v-4.7h4.4v4.7h2.3v-11h-2.3v4.7h-4.4v-4.7h-2.2v11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M138.2 415.5h2.2v-4.7h4.4v4.7h2.3v-11h-2.3v4.7h-4.4v-4.7h-2.2v11zm21.3-15.8h2.2V395h4.4v4.7h2.2v-11h-2.2v4.7h-4.4v-4.7h-2.2v11zm-21.3-30h2.2V365h4.4v4.7h2.3v-11h-2.3v4.7h-4.4v-4.7h-2.2v11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m127.6 387.1 7-5.8h3.6v3h-3.5v1.4h5.3v-5.8h-5.3v-4.3h-7.1v4.3h1.7V377h3.6v3l-7.1 5.7-7-5.8V377h3.4v3h1.8v-4.4h-7v4.3h-5.4v5.8h5.3v-1.5h-3.5v-2.8h3.5l7.1 5.7-7 5.8h-3.6v-3h3.5v-1.4h-5.3v5.8h5.3v4.3h7.1v-4.3h-1.8v2.9h-3.5v-2.9l7-5.8 7.2 5.8v2.9h-3.6v-2.9h-1.7v4.3h7v-4.3h5.4v-5.8h-5.4v1.5h3.6v2.9h-3.5l-7.1-5.8z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 .92857 198.4 17.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "m-122.3 134.3 3.4-3.8h20.6l15.4-16.7h20.6l15.4 16.8h20.6l3.4 3.7-3.4 3.7H-47l-15.4 16.8H-83L-98.3 138H-119l-3.4-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.3,
    d: "m372 391.5 2-2h22.8l17.1-19.4h19l17.2 19.5h22.8l1.9 2-1.9 1.9h-22.8L434.8 411H412l-15.2-17.5h-22.9l-1.9-2z",
    transform: "matrix(.93104 0 0 .90908 -466.9 -221.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#faae29",
    d: "m-64 136.2 6.8 7.4-3.4 3.7-1.8-1.8H-64v1.8l1.7 1.9h3.5l3.4-3.7v-3.8l-6.9-7.4 6.9-7.5v-3.7l-3.4-3.7h-3.5l-1.7 1.8v1.9h1.7l1.8-1.9 3.4 3.8-6.9 7.4-6.8-7.4 6.8-7.5v-1.9h-1.7l-6.8 7.5-6.9-7.5h-1.7v1.9l6.8 7.5-6.8 7.4-6.9-7.4 3.5-3.8 1.7 1.9h1.7v-1.9l-1.7-1.8h-3.5l-3.4 3.7v3.7l6.9 7.5-6.9 7.4v3.8l3.4 3.7h3.5l1.7-1.9v-1.8H-83l-1.7 1.8-3.5-3.7 6.9-7.4 6.8 7.4-6.8 7.5v1.8h1.7l6.9-7.4 6.8 7.4h1.7v-1.8l-6.8-7.5 6.8-7.4zm-8.6-9.4-6.9 7.5 6.9 7.4 6.8-7.4-6.8-7.5zm-10.3 28v15l1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2 1.8 2v-15H-83zm20.6-41v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2v15h20.6zm29 16.8v-15l-1.6 2-1.7-2-1.7 2-1.8-2-1.7 2-1.7-2-1.7 2-1.7-2v15h13.7zm-65 0v-15l-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2v15h13.7zm65.1 7.4v15l-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2-1.7 2v-15h13.7zm-65.2 0v15l-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2-1.7 2v-15h13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00843d",
    d: "M-62.4 154.8v9.3l1.8-1.9 1.7 2 1.7-2 1.7 2 1.7-2 1.7 2 1.8-2 1.7 2 1.7-2V138l-15.5 16.8zm-20.5 0v9.3l-1.8-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.7-2-1.7 2-1.8-2V138l15.5 16.8zm0-41v-9.3l-1.8 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.7 1.8-1.7-1.8-1.8 1.8v24.3l15.5-16.8zm20.5 0v-9.3l1.8 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.7-1.8 1.7 1.8 1.8-1.8 1.7 1.8v24.3l-15.5-16.8zm-49.7 35.4-1.7-1.9-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2v-30l1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2 1.7-2v11.3h-6.8l-3.5 3.7 3.5 3.7h6.8v11.2zm78.9 0 1.7-1.9 1.7 2 1.7-2 1.8 2 1.7-2 1.7 2 1.7-2 1.7 2v-30l-1.7 2-1.7-2-1.7 2-1.7-2-1.8 2-1.7-2-1.7 2-1.7-2v11.3h6.9l3.4 3.7-3.4 3.7h-6.9v11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-91.4 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3h-1.5s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-73.5 161.7s-1.7 2-1.7 3 1.8 3.2 2.6 3.2c1 0 2.5-2.1 2.5-3.1s-1.7-3.1-1.7-3.1v-4.2s3 6.8 3 3.7c0-2-3-5.7-3-5.7h-1.7s-3.5 4.6-3 5.7c0 3.1 3-3.7 3-3.7v4.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -482.4 -277.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -463.5 -277.9)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.9,
    cy: 391.5,
    fill: "#00843d",
    rx: 3.5,
    ry: 1.8,
    transform: "matrix(.96774 0 0 1.0526 -444.7 -277.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-91.7 112.8s-1.4-1.5-1.4-2.2c0-.7 1.5-2.3 2.1-2.3.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-73.9 107s-1.7-2-1.7-3 1.9-3.1 2.6-3.1c1 0 2.6 2 2.6 3s-1.7 3.2-1.7 3.2v4s3-6.7 3-3.6c0 2-3 5.8-3 5.8H-74s-3.5-4.7-3-5.8c0-3 3 3.7 3 3.7V107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-54.9 156s-1.4 1.4-1.4 2.2c0 .7 1.5 2.2 2.2 2.2.8 0 2.1-1.5 2.1-2.2s-1.4-2.2-1.4-2.2v-3s3 5.1 3 2.9c0-1.6-3-4.3-3-4.3H-55s-3 3.2-3 4.3c0 2.2 3-2.9 3-2.9v3zm-.3-43.2s-1.4-1.5-1.4-2.3c0-.6 1.5-2.2 2.1-2.2.8 0 2.1 1.5 2.1 2.2 0 .8-1.4 2.3-1.4 2.3v3s3.1-5.2 3.1-3c0 1.6-3 4.4-3 4.4h-1.5s-3.1-3.2-3.1-4.3c0-2.2 3 2.8 3 2.8v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    d: "M-106.3 145.6s-1.9 1.4-1.9 2c0 .7 2 2.2 2.9 2.1 1 0 2.8-1.3 2.8-2s-1.9-2.1-1.9-2.1v-2.8s3.4 4.5 3.4 2.5c0-1.4-3.4-3.9-3.4-3.9h-1.9s-3.9 3.2-3.3 3.9c0 2 3.3-2.5 3.3-2.5v2.8zm-.4-21.1s-1.9-1.4-1.9-2.1c0-.7 2-2.1 2.9-2 1 0 2.8 1.3 2.8 2s-1.9 2-1.9 2v2.8s3.4-4.5 3.4-2.4c0 1.3-3.4 3.8-3.4 3.8h-1.9s-3.9-3.1-3.3-3.8c0-2 3.3 2.4 3.3 2.4v-2.7zm66.3 20.6s-2 1.4-2 2.1c0 .7 2.1 2.1 3 2.1 1 0 2.8-1.4 2.8-2 0-.8-2-2.2-2-2.2v-2.7s3.4 4.5 3.4 2.4c0-1.3-3.3-3.8-3.3-3.8h-2s-3.8 3.1-3.3 3.8c0 2.1 3.4-2.4 3.4-2.4v2.8zm-.4-21s-2-1.4-2-2.1c0-.7 2.1-2.1 3-2.1 1 0 2.8 1.4 2.8 2 0 .8-2 2.1-2 2.1v2.8s3.4-4.5 3.4-2.5c0 1.4-3.3 3.9-3.3 3.9h-2s-3.8-3.1-3.3-3.8c0-2.1 3.4 2.4 3.4 2.4V124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-120.3 145.4c-.6-1.3-.4-1.9-.4-2.6 0-.7 1.7-2 2.3-2 .8 0 2.1 1.4 2.1 2.2 0 .7 0 1.3-.3 2.6l-.8-2.1c-1.1 3-1.2 3-1.8-.1l-1 2zm0-21.5c-.5 1.3-.4 1.9-.4 2.6 0 .7 1.7 2 2.4 2 .8 0 2.1-1.4 2.1-2.2 0-.7 0-1.3-.3-2.6l-.9 2.1c-1-3-1.1-3-1.8.1l-1-2zm92.5 21.2c-.6-1.3-.5-1.9-.5-2.6 0-.7 1.8-2 2.4-2 .8 0 2.1 1.5 2.1 2.2 0 .7 0 1.4-.3 2.6l-.9-2.1c-1 3-1.1 3.1-1.8 0l-1 1.9zm0-21.4c-.6 1.2-.4 1.8-.4 2.6 0 .6 1.7 2 2.3 2 .8 0 2.2-1.5 2.2-2.2 0-.8 0-1.4-.3-2.7l-1 2.2c-1-3.1-1-3.2-1.7 0l-1-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ca3745",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M115.2 177.2v-5.4h-16v-10.6H85v-3.5H72.6v-32H85v-3.5h14.2v-10.6h16v-5.3h21.2v5.3h16v10.6h14.1v3.6H179v31.9h-12.4v3.5h-14.1v10.6h-16v5.3h-21.2zm-1.8 1.7v-5.3h-16V163H83.3v-3.6H70.9V124h12.4v-3.5h14.1v-10.7h16v-5.3h24.8v5.3h16v10.7h14.1v3.5h12.4v35.4h-12.4v3.6h-14.2v10.6h-16v5.3h-24.7z",
    transform: "matrix(1 0 0 .99999 -198.4 -7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.40ed62d8692dab19760d36a128853992.svg";
export { ForwardRef as ReactComponent };